/**
 * Direct Uploads Module
 * 
 * This module provides client-side direct upload functionality for Azure Blob Storage.
 * Files are uploaded directly from the browser to Azure, bypassing the Rails server.
 * 
 * Features:
 * - Automatic enhancement of Active Admin file inputs
 * - Direct upload support for Tiptap editor
 * - Progress tracking
 * - Error handling
 * 
 * Usage:
 * Import this module in your application.js to enable direct uploads:
 * 
 *   import './direct_uploads';
 */

// Initialize Active Storage (required for direct uploads)
import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();

// Import and auto-initialize Active Admin direct upload enhancement
import './active_admin_direct_upload';

// Export Tiptap-specific upload functions
export {
  uploadToAzure,
  createTiptapUploadHandler,
  uploadDownloadAttachment,
  DIRECT_UPLOAD_URL
} from './tiptap_direct_upload';

// Export general-purpose upload functions
export {
  uploadFileDirectly,
  uploadFilesDirectly,
  processFormFileInput
} from './azure_direct_upload';

console.log('[DirectUploads] Azure direct upload module initialized');

